export const USER = 'user';
export const GET_USERS_BY_ID = `${USER}/getUserAction`;
export const GET_ASSESSOR_EMPLOYEE_MAPPING = `${USER}/getAssessorEmployeeMappingAction`;
export const GET_USERS_BY_ASSESSOR = `${USER}/getUserByAssessorAction`;
export const UPDATE_ASSESSOR = `${USER}/updateAssessorAction`;
export const GET_USER_MANAGEMENT = `${USER}/userManagement`;
export const GET_USER_DETAILS = `${USER}/getUserDetails`;
export const GET_USER_PROFILE = `${USER}/getUserProfile`;
export const UPDATE_USER_PREFERENCE = `${USER}/updateUserPreference`;
export const SUBMIT_SKILL_CHANGE_REQUEST = `${USER}/submitSkillChangeRequest`;
export const SAVE_USER = `${USER}/saveUser`;
export const NOTIFY_USER = `${USER}/notifyUser`;
export const CHECK_USER_EXIST = `${USER}/checkUserExist`;